import { isLoggedIn } from "utils/auth";

export default (store) => {
  return {
    path: "live-reports",
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          const liveReports = require("./LiveReports").default;
          cb(null, liveReports);
        },
        "LiveReports"
      );
    },
  };
};



// WEBPACK FOOTER //
// ./src/routes/LiveReports/index.js